/* Aurelliani cart helpers (our own code).
   - window.AU_CART.add(variantId, qty, source): adds through Shopify's standard action
     Shopify.actions.updateCart (Horizon 4 routes its `shopify:cart:lines-update` event
     from the cart drawer, so the drawer, bubble and cart items refresh and the drawer
     opens). Falls back to /cart/add.js + a CartLinesUpdateEvent when the bundle is absent.
   - window.AU_CART.variantFor(handle): first available variant id of a product.
   - <au-ship-bar>: free-shipping progress bar, recalculated whenever the cart changes.
   - <au-cart-recs>: "You may also like" row from /recommendations/products.json.
   Both elements carry data-skip-subtree-update so the theme's morph keeps the
   client-rendered children and only refreshes their data-* attributes. */
(function () {
  'use strict';
  if (window.AU_CART) return;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var EVENT = 'shopify:cart:lines-update';

  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    var n = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: cur, minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2
      }).format(n);
    } catch (e) { return '$' + n.toFixed(2); }
  }
  function esc(s) {
    var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML;
  }
  function actions() { return window.Shopify && Shopify.actions; }
  /* The drawer opens itself on an "add" when auto-open is on; otherwise ask the standard action. */
  function openDrawer() {
    var d = document.querySelector('cart-drawer-component');
    if (d && d.hasAttribute('auto-open')) return;
    var a = actions();
    if (a && a.openCart) { a.openCart().catch(function () {}); }
  }

  function add(variantId, qty, source) {
    var a = actions();
    if (a && a.updateCart) {
      return a.updateCart(
        { lines: [{ merchandiseId: String(variantId), quantity: qty || 1 }] },
        { event: { context: 'product', detail: { source: source || 'au-cart' } } }
      ).then(function (res) {
        if (res && res.userErrors && res.userErrors.length) {
          throw { description: res.userErrors[0].message };
        }
        openDrawer();
        return res && res.cart;
      });
    }
    /* Fallback: AJAX add, then the standard event so Horizon's cart UI refreshes. */
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty || 1 }] })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; });
    }).then(function () {
      return import('@shopify/events').then(function (ev) {
        var deferred = ev.CartLinesUpdateEvent.createPromise();
        document.dispatchEvent(new ev.CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: String(variantId), quantity: qty || 1 }],
          promise: deferred.promise
        }));
        return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            deferred.resolve({ cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart) });
            openDrawer();
            return cart;
          });
      });
    });
  }

  function variantFor(handle) {
    return fetch(ROOT + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('product'); return r.json(); })
      .then(function (p) {
        var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0];
        if (!v) throw new Error('variant');
        return v.id;
      });
  }

  /* Button helper shared by the catalog grid and the cart cross-sell:
     <button data-au-add data-v="variant id"> or data-h="product handle". */
  function handleButton(btn, source) {
    if (!btn || btn.disabled) return;
    var label = btn.querySelector('[data-au-add-label]') || btn;
    var original = label.textContent;
    btn.disabled = true; btn.classList.add('is-busy'); btn.setAttribute('aria-busy', 'true');
    var getId = btn.dataset.v ? Promise.resolve(btn.dataset.v) : variantFor(btn.dataset.h);
    getId.then(function (id) { return add(id, 1, source); }).then(function () {
      btn.classList.remove('is-busy'); btn.classList.add('is-added');
      label.textContent = btn.dataset.added || 'Added';
      setTimeout(function () {
        btn.classList.remove('is-added'); label.textContent = original; btn.disabled = false; btn.removeAttribute('aria-busy');
      }, 1600);
    }).catch(function (err) {
      btn.classList.remove('is-busy'); btn.classList.add('is-error');
      label.textContent = (err && err.description && String(err.description).length < 40) ? err.description : (btn.dataset.error || 'Not available');
      setTimeout(function () {
        btn.classList.remove('is-error'); label.textContent = original; btn.disabled = false; btn.removeAttribute('aria-busy');
      }, 2200);
    });
  }

  window.AU_CART = { add: add, variantFor: variantFor, handleButton: handleButton, money: money, event: EVENT };

  /* ---------- free-shipping progress ---------- */
  class AuShipBar extends HTMLElement {
    static get observedAttributes() { return ['data-total', 'data-threshold']; }
    connectedCallback() {
      if (!this._onCart) {
        this._onCart = (e) => {
          var self = this;
          var p = e && e.promise;
          if (!p || typeof p.then !== 'function') return;
          p.then(function (res) {
            var amt = res && res.cart && res.cart.cost && res.cart.cost.totalAmount && res.cart.cost.totalAmount.amount;
            if (amt != null && !isNaN(Number(amt))) self.setAttribute('data-total', String(Math.round(Number(amt) * 100)));
          }).catch(function () {});
        };
        document.addEventListener(EVENT, this._onCart);
      }
      this.render();
    }
    disconnectedCallback() {
      if (this._onCart) document.removeEventListener(EVENT, this._onCart);
      this._onCart = null;
    }
    attributeChangedCallback() { if (this.isConnected) this.render(); }
    render() {
      var rate = Number(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
      var thr = Math.round((Number(this.dataset.threshold) || 0) * rate);
      var total = Number(this.dataset.total) || 0;
      var text = this.querySelector('.au-ship__text');
      var track = this.querySelector('.au-ship__track');
      var fill = this.querySelector('.au-ship__fill');
      if (!thr || !text || !fill) return;
      var left = Math.max(thr - total, 0);
      var pct = Math.min(100, Math.round((total / thr) * 100));
      text.textContent = left > 0
        ? String(this.dataset.away || '').replace('[amount]', money(left))
        : String(this.dataset.done || '');
      fill.style.width = pct + '%';
      if (track) track.setAttribute('aria-valuenow', String(pct));
      this.classList.toggle('is-done', left === 0);
    }
  }
  if (!customElements.get('au-ship-bar')) customElements.define('au-ship-bar', AuShipBar);

  /* ---------- cross-sell ---------- */
  var RECS = {};
  class AuCartRecs extends HTMLElement {
    static get observedAttributes() { return ['data-product-id', 'data-exclude']; }
    connectedCallback() {
      this.addEventListener('click', this._onClick = (e) => {
        var b = e.target.closest('[data-au-add]');
        if (b && this.contains(b)) { e.preventDefault(); handleButton(b, 'au-cart-recs'); }
      });
      this.load();
    }
    disconnectedCallback() { if (this._onClick) this.removeEventListener('click', this._onClick); }
    attributeChangedCallback(name, oldV, newV) { if (this.isConnected && oldV !== newV) this.load(); }
    load() {
      var pid = this.dataset.productId;
      var wrap = this.querySelector('.au-recs__in');
      if (!pid || !wrap) { if (wrap) wrap.hidden = true; return; }
      var limit = Number(this.dataset.limit) || 3;
      var ex = (this.dataset.exclude || '').split(',').filter(Boolean);
      var ask = Math.min(10, limit + ex.length);
      var key = pid + ':' + ask;
      var base = this.dataset.url || (ROOT + 'recommendations/products');
      RECS[key] = RECS[key] || fetch(base + '.json?product_id=' + encodeURIComponent(pid) + '&limit=' + ask + '&intent=related', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (j) { return j.products || []; })
        .catch(function () { return []; });
      var token = this._token = key + '|' + ex.join(',');
      RECS[key].then((list) => { if (this._token === token) this.render(list, ex, limit); });
    }
    render(list, ex, limit) {
      var wrap = this.querySelector('.au-recs__in');
      var ul = this.querySelector('.au-recs__list');
      if (!wrap || !ul) return;
      list = list.filter(function (p) { return p.available && ex.indexOf(String(p.id)) === -1; }).slice(0, limit);
      if (!list.length) { wrap.hidden = true; ul.innerHTML = ''; return; }
      var addLabel = this.dataset.addLabel || 'Add';
      var viewLabel = this.dataset.viewLabel || 'View';
      ul.innerHTML = list.map(function (p) {
        var img = p.featured_image || (p.images && p.images[0]) || '';
        if (img) img += (img.indexOf('?') === -1 ? '?' : '&') + 'width=240';
        var url = p.url || (ROOT + 'products/' + p.handle);
        var vs = (p.variants || []).filter(function (v) { return v.available; });
        var single = (p.variants || []).length === 1 && vs.length === 1;
        var price = (p.price_varies ? 'From ' : '') + money(p.price);
        return '<li class="au-recs__item">' +
          '<a class="au-recs__media" href="' + esc(url) + '" tabindex="-1" aria-hidden="true">' +
            (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="120" height="120">' : '') + '</a>' +
          '<div class="au-recs__info"><a class="au-recs__t" href="' + esc(url) + '">' + esc(p.title) + '</a>' +
          '<span class="au-recs__p">' + esc(price) + '</span></div>' +
          (single
            ? '<button type="button" class="au-recs__btn" data-au-add data-v="' + esc(vs[0].id) + '" aria-label="' + esc(addLabel + ': ' + p.title) + '"><span data-au-add-label>' + esc(addLabel) + '</span></button>'
            : '<a class="au-recs__btn" href="' + esc(url) + '" aria-label="' + esc(viewLabel + ': ' + p.title) + '">' + esc(viewLabel) + '</a>') +
          '</li>';
      }).join('');
      wrap.hidden = false;
    }
  }
  if (!customElements.get('au-cart-recs')) customElements.define('au-cart-recs', AuCartRecs);
})();
